import { DateTime } from 'luxon';

export const ISODateValidator = (props, propName, componentName) => {
  const prop = props[propName];

  // Props that were not set are `undefined`, this validator will not throw on those.
  // Makes it "optional"
  if (typeof prop !== 'undefined') {
    const parsedDate = DateTime.fromISO(prop);
    if (parsedDate.invalid) {
      return new Error(
        `Invalid prop ${propName} supplied to ${componentName}. Validation failed: ${parsedDate.invalid.explanation}`
      );
    }
  }
};
